import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZoomInIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5 17.5L13.875 13.875M9.16667 6.66667V11.6667M6.66667 9.16667H11.6667M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z",
		stroke: "currentColor",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgZoomInIcon;
